export default __webpack_public_path__ + "static/testimonial-bg-b7916450080c17ee82fc6a83d14b720b.png";